var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"certification"},[_c('div',{staticClass:"tiltle"},[_vm._v("企业信息")]),_c('div',{staticClass:"gallery"},_vm._l((_vm.certificates),function(certificate,index){return _c('div',{key:index,staticClass:"certificate-item"},[_c('el-image',{attrs:{"src":certificate.url,"preview-src-list":_vm.srcList}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }